
window._ = require('lodash');
window.Popper = require('popper.js').default;
window.typehead      = require('typeahead.js');
window.Bloodhound    = require('typeahead.js/dist/bloodhound');
window.Handlebars    = require('handlebars');
window.toastr = require('toastr');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
    require('@coreui/coreui');
    require('icheck');
    require('bootstrap-datepicker');
    require('bootstrap-datepicker/js/locales/bootstrap-datepicker.pl');
    require('ckeditor');
} catch (e) {
    console.log(e);
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found!');
}



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js